import { FiUsers } from "react-icons/fi";
import Loader from "../Loader";
import TableOverviewCard from "../TableOverviewCard";

const AdminTableOverview = ({ loading, total }) => {
    return (
        <>
            {loading ? (
                <Loader
                    loading={loading}
                    className={"min-h-[20px]"}
                    size={20}
                />
            ) : null}

            <div className="table_wrapper">
                <div className="table_header !min-w-[500px]">
                    <TableOverviewCard
                        icon={<FiUsers className="text-morning_blue" />}
                        label={"Total Admins"}
                        value={total || 0}
                        valueBackgroundColor={"bg-azureish_white"}
                        valueColor={"text-primary"}
                    />

                    {/* <TableOverviewCard
                        icon={<FiUsers className="text-morning_blue" />}
                        label={"Total Male Teachers"}
                        value={0}
                        valueBackgroundColor={"bg-azureish_white"}
                        valueColor={"text-primary"}
                    /> */}

                    {/* <TableOverviewCard
                        icon={<FiUsers className="text-morning_blue" />}
                        label={"Total Female Teachers"}
                        value={0}
                        valueBackgroundColor={"bg-banana_mania"}
                        valueColor={"text-saffron"}
                    /> */}

                    <TableOverviewCard
                        icon={<FiUsers className="text-morning_blue" />}
                        label={"Pending Invites"}
                        value={0}
                        valueBackgroundColor={"bg-water"}
                        valueColor={"text-secondary"}
                    />
                </div>
            </div>
        </>
    );
};

export default AdminTableOverview;
